import { globalGet, get, post } from '@api/request';

export const fetchPreference = async (
  { userService },
  authenticationToken,
  { userId },
) => {
  const url = `${userService}/trueprodigy/user/${userId}/preference/ci`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const persistPreference = async (
  { userService },
  authenticationToken,
  { userId, data },
) => {
  const url = `${userService}/trueprodigy/user/${userId}/preference/ci`;
  const { body } = await post(authenticationToken, url, data);
  return body;
};

export async function getElevation(baseUrl, authenticationToken, { location }) {
  // const url = `https://maps.googleapis.com/maps/api/elevation/json?locations=${encodeURI(location.lat)},${encodeURI(location.lng)}&key=${key}`;
  const url = `https://elevation-api.io/api/elevation?points=(${encodeURI(
    location.lat,
  )},${encodeURI(location.lng)})`;
  let body;
  if (location.lat === undefined || location.lng === undefined) {
    body = {
      body: {
        elevations: [
          {
            elevation: 171,
          },
        ],
      },
    };
  } else {
    body = await globalGet(url);
  }
  return body;
}

export async function getBingGeoCode(
  baseUrl,
  authenticationToken,
  { address, key },
) {
  // const url = `https://maps.googleapis.com/maps/api/elevation/json?locations=${encodeURI(location.lat)},${encodeURI(location.lng)}&key=${key}`;
  const url = `https://dev.virtualearth.net/REST/v1/Locations?q=${encodeURI(
    address,
  )}&key=${key}`;
  const body = await globalGet(url);
  return body;
}
